// ---------------------------------------------------------------------------
// Real visible-viewport height → CSS var --app-vh
// ---------------------------------------------------------------------------
// On mobile the CSS `100vh` / `100dvh` units are NOT reliably equal to the
// actually-visible height: Samsung Internet / mobile Chrome reserve space for
// the URL bar (top) and toolbar (bottom), and 100dvh on some devices resolves
// TALLER than the visible area. That made the "locked" appointment screen
// (fixed calendar + internally-scrolling time list + pinned "אישור") overflow
// below the fold, so the time slots slid under the button and the whole page
// scrolled instead of just the time list. DevTools has no such browser chrome,
// so it never reproduced there.
//
// Fix: measure the real visible height via the visualViewport API (falling back
// to innerHeight) and publish it as `--app-vh`. The layout locks to that exact
// pixel height instead of 100dvh. Updated on every resize / viewport change so
// it stays correct through rotation and URL-bar transitions.
// ---------------------------------------------------------------------------

export function installAppHeight() {
  const vv = window.visualViewport;

  const apply = () => {
    // visualViewport.height excludes the URL bar / toolbar (the true visible area);
    // innerHeight is the fallback for the rare browser without visualViewport.
    const h = (vv && vv.height) ? vv.height : window.innerHeight;
    const root = document.documentElement;
    root.style.setProperty('--app-vh', h + 'px');
    // Drive the calendar-compression by the REAL visible height, not a CSS max-height
    // media query (which measures the taller layout viewport and so never fires on
    // phones with browser chrome). Less visible height → tighter calendar → the time
    // list keeps 2-3 selectable rows instead of being squeezed to one.
    root.classList.toggle('app-short', h < 850);   // most phones with browser chrome
    root.classList.toggle('app-vshort', h < 700);  // small / older phones
  };

  apply();

  // visualViewport fires on URL-bar show/hide, pinch-zoom and keyboard; window
  // resize/orientation cover the rest.
  if (vv) {
    vv.addEventListener('resize', apply);
    vv.addEventListener('scroll', apply);
  }
  window.addEventListener('resize', apply);
  window.addEventListener('orientationchange', apply);
}
